import { atom } from "recoil"

const imgUpload = atom({
  key: "imgUpload",
  default: null,
})

export default imgUpload
